export default "__VITE_ASSET__BKZuGPht__"